<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <div v-if="!isLoading" ref="scrollElement" :class="containerStyles">
    <figure
      class="col-start-2 col-span-12 md:col-start-3 md:col-span-10 md:grid md:grid-cols-10 md:gap-x-[5rem] [&_*]:text-typography"
    >
      <custom-image
        v-if="image"
        :alt="imgAlt"
        :image="image"
        :imageCrop="imageCrop"
        classes="w-full h-full object-cover md:col-span-10"
        loading="lazy"
      />
      <figcaption
        v-if="imageCaption"
        :class="`text-sm mt-2 md:col-span-6 md:col-start-3 ${themeType}`"
      >
        {{ imageCaption }}
      </figcaption>
    </figure>
  </div>
</template>

<script lang="ts" setup>
import { Theme } from "@/types/types";
import { computed, onMounted, toRefs, ref, Ref, onUnmounted, watch } from "vue";
import { changeTheme, getThemeType } from "@/util/helper";
import { onIntersect } from "@/composables/onIntersect";
import CustomImage from "@atoms/Image/Img.vue";

const props = withDefaults(
  defineProps<{
    image: string;
    imgAlt?: string;
    imageCaption?: string;
    isUmbraco?: boolean;
    imageCrop?: boolean;
    theme?: Theme;
  }>(),
  { isUmbraco: false, theme: "sand" }
);

const { image, imgAlt, imageCaption, isUmbraco, theme, imageCrop } = toRefs(props);

const observer: Ref<IntersectionObserver | null> = ref(null);
const scrollElement = ref(null);

const onEnter = () => {
  changeTheme(theme.value);
};
const onExit = () => {};

onMounted(() => {
  observer.value = onIntersect(scrollElement.value, onEnter, onExit, false, {
    threshold: 0.6,
  });
});

onUnmounted(() => {
  if (!observer.value) return;
  observer.value.disconnect();
});

watch(theme, (value) => {
  if (!value) return;
  changeTheme(value);
});

const themeType = computed(() => {
  return getThemeType(theme.value);
});

const containerStyles = computed(() => {
  const bgColor = isUmbraco.value ? `bg-${theme.value}` : ``;
  return `${bgColor} sectionContainer lg:min-h-full py-10 py-[60px]`;
});
</script>
